import * as React from 'react';
import { ThemeProvider, useTheme } from '../../../../../../theme';
import { BaggageDelivery as BaggageDeliveryRoot } from '../../../../../../CheckoutAdditionalService/components';
import { CheckedBaggage } from '../../../../../../Icons';
const BaggageDelivery = () => {
    const { ServicesAggregationPage: theme } = useTheme('Checkout');
    return (React.createElement(ThemeProvider, { value: { CheckoutAdditionalService: { BaggageDelivery: { baggageDelivery: theme.baggageDelivery } } } },
        React.createElement(BaggageDeliveryRoot, { aggregationIcons: [CheckedBaggage], aggregationMode: true })));
};
export default BaggageDelivery;
